import { Fragment as e, createContext as t, forwardRef as n, memo as r, useCallback as i, useContext as a, useEffect as o, useImperativeHandle as s, useMemo as c, useRef as l, useState as u } from "react";
import { BeautifulObjectLayer as d, ClickableMarkerLayer as f, ConstellationLayer as p, EsoMilkyWayLayer as m, Globe as h, GridLayer as g, HipparcosCatalogLayer as _, Layer as v, MarkerLayer as y, PanLayer as ee, PathLayer as b, PointerLockLayer as te, RollLayer as ne, TextLayer as re, TouchLayer as ie, TractTileLayer as x, ZoomLayer as ae, beautifulObjectIds as oe, glMatrix as se, hips as ce, overlayAlpha as le } from "@stellar-globe/stellar-globe";
import { Fragment as ue, jsx as S, jsxs as de } from "react/jsx-runtime";
//#region src/hooks/useInstanceVariable.ts
function C(e) {
	return l(c(e, [])).current;
}
//#endregion
//#region src/GlobeContext.tsx
function fe() {
	return l({}).current;
}
function pe({ jsdomTest: e, projection: t = "STEREOGRAPHIC", retina: n = !1, preserveBuffer: r, noDefaultLayers: a, cameraParams: s, onInit: u, onRelease: d }) {
	let f = l(null), p = C(() => ({
		globe: void 0,
		layers: /* @__PURE__ */ new Map(),
		layerFactories: /* @__PURE__ */ new Map()
	})), m = l({
		retina: n,
		noDefaultLayers: a,
		cameraParams: s,
		projection: t
	}), { layers: g, layerFactories: _ } = p, v = i((e, t, n, r) => {
		if (p.globe) {
			let i = r(p.globe);
			g.set(e, {
				layer: i,
				el: t
			}), n && p.globe.addLayer(i);
		} else _.set(e, {
			factory: r,
			el: t,
			visible: n
		});
	}, [
		_,
		g,
		p
	]), y = i((e, t) => {
		let n = /* @__PURE__ */ new Map();
		for (let [, { el: e, layer: t }] of g) n.set(t, e);
		return he(n.get(e), n.get(t));
	}, [g]);
	return o(function() {
		p.globe && p.globe.camera.jumpTo({ mode: t });
	}, [t, p]), o(function() {
		p.globe && p.globe.camera.setRetina(n);
	}, [n, p]), o(function() {
		p.globe && s && (Object.assign(p.globe.camera, ge(s)), p.globe.requestRefresh());
	}, [s, p.globe]), o(function() {
		let t = new h(f.current, {
			jsdomTest: e,
			preserveBuffer: r,
			viewOptions: {
				...m.current.cameraParams,
				retina: m.current.retina,
				mode: m.current.projection
			},
			noDefaultLayers: m.current.noDefaultLayers
		});
		u?.(t), t.layerSorter.setSortFunc(y), p.globe = t;
		for (let [e, { factory: t, el: n, visible: r }] of _) v(e, n, r, t);
		return _.clear(), () => {
			for (let [, { layer: e }] of Array.from(g).reverse()) e.release();
			if (g.clear(), d?.(t), t.release(), _.size > 0) throw console.error(_), Error("layerFactories is not empty");
			p.globe = void 0;
		};
	}, [
		y,
		e,
		_,
		g,
		u,
		d,
		r,
		v,
		p
	]), c(() => ({
		state: p,
		containerRef: f,
		registerLayer: v
	}), [v, p]);
}
var w = t(void 0);
function T() {
	let e = a(w);
	if (e === void 0) throw Error("use of useGlobeContext outside <$Globe />");
	return e;
}
function E() {
	let e = T();
	return i(() => {
		if (e.state.globe === void 0) throw Error("globe has not been set up yet");
		return e.state.globe;
	}, [e]);
}
function D(e, t) {
	let n = fe(), { state: r, registerLayer: a } = T(), { layerFactories: s, layers: c } = r, u = l(null);
	o(function() {
		let e = c.get(n);
		if (e) {
			let { layer: n } = e;
			t ? n.globe.addLayer(n) : n.globe.removeLayer(n);
		}
	}, [
		n,
		c,
		t
	]), o(function() {
		return a(n, u.current, t, e), () => {
			s.delete(n), c.has(n) && (c.get(n).layer.release(), c.delete(n));
		};
	}, [
		e,
		n,
		s,
		c,
		a
	]);
	let d = i((e) => {
		let t = c.get(n);
		if (t) {
			let { layer: n } = t;
			return e(n);
		}
	}, [n, c]);
	return {
		node: /* @__PURE__ */ S("div", { ref: u }),
		ifLayerReady: d
	};
}
function O(e, t) {
	return (n) => {
		let { [t]: r = !0, ...a } = n, o = me(a), s = l(n);
		s.current = n;
		let { node: c } = D(i((t) => e(t, s.current), [e, o]), r);
		return c;
	};
}
function k(e, t) {
	return function(n) {
		let { [t]: r = !0 } = n, [i, a] = u(r);
		return o(() => {
			r && a(!0);
		}, [r]), i && /* @__PURE__ */ S(e, { ...n });
	};
}
function A(e) {
	for (let t of Object.keys(e)) e[t].displayName = t;
}
function me(e) {
	let t = l(e), n = t.current, r = Object.keys(n), i = Object.keys(e);
	return (r.length !== i.length || i.some((t) => !Object.prototype.hasOwnProperty.call(n, t) || !Object.is(n[t], e[t]))) && (t.current = e), t.current;
}
function he(e, t) {
	if (e && t) {
		let n = e.compareDocumentPosition(t);
		return n & 2 ? 1 : n & 4 ? -1 : 0;
	}
	return e ? 1 : t ? -1 : 0;
}
function ge(e) {
	let { theta: t, phi: n, za: r, zd: i, zp: a, fovy: o, roll: s } = e;
	return {
		theta: t,
		phi: n,
		za: r,
		zd: i,
		zp: a,
		fovy: o,
		roll: s
	};
}
//#endregion
//#region src/Globe.tsx
var j = n(function({ children: e, ...t }, n) {
	let r = pe(t), { containerRef: i, state: { globe: a } } = r;
	return s(n, () => () => r.state.globe, [r.state]), o(() => {
		a?.layerSorter.sort();
	}), /* @__PURE__ */ S(w.Provider, {
		value: r,
		children: /* @__PURE__ */ S("div", {
			ref: i,
			style: {
				height: "100%",
				position: "relative"
			},
			children: e
		})
	});
});
A({ Globe: j });
var _e = j, ve = r(function({ min: e, max: t, a: n = 1, nStep: r = 1e4, value: a, onInput: o, className: s, style: l }) {
	let u = (e) => Math.sinh(n * e) / Math.sinh(n), d = i((e) => Math.asinh(e * Math.sinh(n)) / n, [n]), f = c(() => d(e), [d, e]), p = c(() => d(t), [d, t]), m = c(() => (d(a) - f) / (p - f) * r, [
		d,
		r,
		a,
		p,
		f
	]), h = (e) => {
		let t = e / r, n = f + t * (p - f);
		o(u(n));
	};
	return /* @__PURE__ */ S("input", {
		type: "range",
		min: 0,
		max: r,
		step: 1,
		value: m,
		onChange: (e) => h(Number(e.target.value)),
		className: s,
		style: l
	});
}), ye = k(r(({ which: e, params: t, visible: n = !0 }) => {
	let r = l(t);
	r.current = t;
	let { node: a, ifLayerReady: s } = D(i((t) => new d(t, e, r.current), [e]), n);
	return o(() => {
		t && s((e) => e.setMixerParams(t));
	}, [s, t]), a;
}), "visible"), M = r(({ visible: e, params: t }) => /* @__PURE__ */ S(ue, { children: oe.map((n) => /* @__PURE__ */ S(ye, {
	visible: e,
	which: n,
	params: t?.[n]
}, n)) }));
A({ BeautifulObjectLayer: M });
var be = M, N = r((e) => {
	let { visible: t = !0, ...n } = {
		...p.defaultOptions(),
		...e
	}, { lang: r, nameColor: a, nameFont: s, showLines: c, showNames: l } = n, { node: u, ifLayerReady: d } = D(i((e) => new p(e, n), [
		r,
		a,
		s
	]), t);
	return o(() => {
		d((e) => {
			e.showLines = c, e.showNames = l, e.globe.requestRefresh();
		});
	}, [
		d,
		c,
		l
	]), u;
});
A({ ConstellationLayer: N });
var xe = N, P = O((e) => new ee(e), "enabled"), F = O((e, { invertX: t, invertY: n }) => new te(e, {
	invertX: t,
	invertY: n
}), "enabled"), I = O((e) => new ae(e), "enabled"), L = O((e) => new ne(e), "enabled"), R = O((e) => new ie(e), "enabled");
A({
	PanLayer: P,
	PointerLockLayer: F,
	ZoomLayer: I,
	RollLayer: L,
	TouchLayer: R
});
var Se = P, Ce = I, we = L, z = R, B = k(O((e, t) => new m(e, t), "visible"), "visible");
A({ EsoMilkyWayLayer: B });
var Te = B, Ee = class extends v {}, V = {
	onPointerDown: "pointer-down",
	onPointerUp: "pointer-up",
	onPointerMove: "pointer-move",
	onCameraModeChange: "camera-mode-change",
	onCameraMoveStart: "camera-move-start",
	onCameraMove: "camera-move",
	onCameraMoveEnd: "camera-move-end",
	onImageLoaded: "imageloadend",
	onResize: "resize"
}, H = r((e) => {
	let t = C(() => /* @__PURE__ */ new Map()), n = (n, r) => {
		t.get(r)?.(), t.delete(r);
		let i = e[r];
		if (i) {
			let e = n.on(V[r], i);
			t.set(r, e);
		}
	}, { node: r, ifLayerReady: a } = D(i((e) => {
		for (let t of Object.keys(V)) n(e, t);
		return new Ee(e);
	}, []), !0);
	for (let t of Object.keys(V)) o(() => {
		a((e) => n(e.globe, t));
	}, [e[t]]);
	return r;
});
A({ GlobeEventLayer: H });
var De = H, U = O((e, { optionsManipulate: t }) => new g(e, t), "visible");
A({ GridLayer: U });
var Oe = U, W = k(O((e) => new _(e), "visible"), "visible");
A({ HipparcosCatalogLayer: W });
var ke = W, G = O((e, { baseUrl: t, animationLod: n }) => new ce.SimpleImageLayer(e, t, { animationLod: n }), "visible");
A({ HipsSimpleLayer: G });
var Ae = G, K = r((e) => {
	let { visible: t = !0, ...n } = e, { node: r, ifLayerReady: a } = D(i((e) => new y(e, n), []), t), { defaultColor: s, defaultType: c, markers: l, baseColor: u, markerSize: d, markerWidth: f } = n;
	return o(() => {
		a((e) => {
			e.update({
				defaultColor: s,
				defaultType: c,
				markers: l,
				markerSize: d,
				markerWidth: f
			});
		});
	}, [
		s,
		c,
		a,
		d,
		f,
		l
	]), o(() => {
		a((e) => {
			e.baseColor = u, e.globe.requestRefresh();
		});
	}, [u, a]), r;
});
A({ MarkerLayer: K });
var je = K, q = r((e) => {
	let { visible: t = !0, ...n } = e, { node: r, ifLayerReady: a } = D(i((e) => new f(e, n), []), t), { defaultColor: s, defaultType: c, markers: l, dimmAlpha: u, onClick: d, onHoverChange: p, baseColor: m, markerSize: h, markerWidth: g } = n;
	return o(() => {
		a((e) => {
			e.update({
				defaultColor: s,
				defaultType: c,
				markers: l,
				markerSize: h,
				markerWidth: g
			});
		});
	}, [
		s,
		c,
		a,
		l,
		u,
		h,
		g
	]), o(() => {
		a((e) => {
			e.dimmAlpha = u, e.baseColor = m, e.onClick = d, e.onHoverChange = p, e.globe.requestRefresh();
		});
	}, [
		m,
		u,
		a,
		d,
		p
	]), r;
});
A({ ClickableMarkerLayer: q });
var Me = q, J = r((e) => {
	let { visible: t = !0, ...n } = e, { node: r, ifLayerReady: a } = D(i((e) => new b(e, n), []), t), { paths: s, blendMode: c, dimOnZoom: l, darkenNarrowLine: u } = n;
	return o(() => {
		a((e) => {
			e.paths = s;
		});
	}, [a, s]), o(() => {
		a((e) => {
			let t = b.defaultOptions();
			e.blendeMode = c ?? t.blendMode, e.dimOnZoom = l ?? t.dimOnZoom, e.darkenNarrowLine = u ?? t.darkenNarrowLine;
		});
	}, [
		c,
		u,
		l,
		a
	]), r;
});
A({ PathLayer: J });
var Ne = J, Y = r((e) => {
	let { visible: t = !0, ...n } = e, { defaultColor: r, defaultFont: a, texts: s, alphaFunc: c = le } = n, { node: l, ifLayerReady: u } = D(i((e) => new re(e, n), []), t);
	return o(() => {
		u((e) => {
			e.update({
				texts: s,
				defaultColor: r ?? null,
				defaultFont: r ?? null
			});
		});
	}, [
		u,
		s,
		r,
		a
	]), o(() => {
		u((e) => {
			e.alphaFunc = c, e.globe.requestRefresh();
		});
	}, [c, u]), l;
});
A({ TextLayer: Y });
var Pe = Y;
function Fe() {
	return 1;
}
//#endregion
//#region src/layers/TractTileLayer.ts
var X = k(r((e) => {
	let { baseUrl: t, colorParams: n = x.defaultParams({ type: "sdssTrueColor" }), outline: r = !1, visible: a = !0, magFilter: s = "linear", filterNameDictionary: c } = e, { node: l, ifLayerReady: u } = D(i((t) => new x(t, {
		...e,
		colorParams: Z(n, c)
	}), [t]), a);
	return o(() => {
		u((e) => {
			e.outline = r, e.globe.requestRefresh();
		});
	}, [u, r]), o(() => {
		u((e) => {
			e.setParams(Z(n, c));
		});
	}, [
		n,
		c,
		u
	]), o(() => {
		u((e) => {
			e.setMagFilter(s);
		});
	}, [u, s]), l;
}), "visible");
A({ TractTileLayer: X });
var Ie = X;
function Z(e, t) {
	if (t) {
		let n = e.filters.map((e) => t[e] ?? e);
		return {
			...e,
			filters: n
		};
	}
	return e;
}
//#endregion
//#region src/layers/DomLayer.tsx
var { vec4: Q } = se, Le = class extends v {
	shared;
	constructor(e, t) {
		super(e), this.shared = t;
	}
	render(e) {
		let t = Q.transformMat4(Q.create(), [...this.shared.position, 1], e.mvp.pv), n = t[0] / t[3], r = t[1] / t[3], i = t[2] / t[3], a = -1 <= n && n <= 1 && -1 <= r && r <= 1 && -1 <= i && i <= 1;
		this.shared.onProject({
			x: n,
			y: r,
			visible: a
		});
	}
};
function $({ children: t, position: n, offset: r = [0, 0], visible: a = !0 }) {
	let s = E(), u = i(({ visible: e, x: t, y: n }) => {
		if (h.current) if (e) {
			let { width: e, height: i } = s().gl.canvas.getBoundingClientRect(), a = `translateX(${`${e * (t + 1) / 2 + r[0]}px`}) translateY(${`${i * (1 - (n + 1) / 2) + r[1]}px`})`;
			Object.assign(h.current.style, {
				display: "block",
				left: 0,
				top: 0,
				transform: a
			});
		} else Object.assign(h.current.style, { display: "none" });
	}, [s, r]), d = l({
		position: n,
		onProject: u
	}), { node: f, ifLayerReady: p } = D(i((e) => new Le(e, d.current), []), a), m = c(() => ({
		position: n,
		onProject: u
	}), [u, n]);
	o(() => {
		p((e) => {
			e.shared = m, e.globe.requestRefresh();
		});
	}, [p, m]);
	let h = l(null);
	return /* @__PURE__ */ de(e, { children: [f, /* @__PURE__ */ S("div", {
		ref: h,
		style: { position: "absolute" },
		children: t
	})] });
}
var Re = $;
//#endregion
export { M as BeautifulObjectLayer, be as BeautifulObjectLayer$, q as ClickableMarkerLayer, Me as ClickableMarkerLayer$, N as ConstellationLayer, xe as ConstellationLayer$, $ as DomLayer, Re as DomLayer$, B as EsoMilkyWayLayer, Te as EsoMilkyWayLayer$, j as Globe, _e as Globe$, H as GlobeEventLayer, De as GlobeEventLayer$, U as GridLayer, Oe as GridLayer$, W as HipparcosCatalogLayer, ke as HipparcosCatalogLayer$, G as HipsSimpleLayer, Ae as HipsSimpleLayer$, ve as LogScaleRange, K as MarkerLayer, je as MarkerLayer$, P as PanLayer, Se as PanLayer$, J as PathLayer, Ne as PathLayer$, F as PointerLockLayer, L as RollLayer, we as RollLayer$, Y as TextLayer, Pe as TextLayer$, R as TouchLayer, z as TouchLayer$, X as TractTileLayer, Ie as TractTileLayer$, I as ZoomLayer, Ce as ZoomLayer$, Fe as alwaysOne, O as makePureLayerComponent, k as mountOndemand, E as useGetGlobe, D as useLayerBind };

//# sourceMappingURL=react-stellar-globe.es.js.map